import { Tooltip } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { useFooter } from '../../hooks';
import { updateImageUrl } from '../../utils';
import { PAYMENT_METHOD, PAYMENT_METHODS, jpgSettings } from './constants';
import { Item, Root } from './styles';

export const PaymentMethods: FC = () => {
  const { getTestId } = useTestId();
  const { paymentMethodsItems } = useFooter();

  if (!paymentMethodsItems || paymentMethodsItems.length === 0) {
    return null;
  }

  return (
    <Root data-testid={getTestId(PAYMENT_METHODS)}>
      {paymentMethodsItems.map((pm, index) => (
        <Tooltip
          key={pm.imageUrl ?? index}
          title={pm.title ?? ''}
          placement="top"
        >
          <Item
            data-testid={getTestId(PAYMENT_METHOD)}
            src={updateImageUrl({ url: pm.imageUrl, passPNG: true, jpgSettings })}
            alt={pm.title ?? ''}
          />
        </Tooltip>
      ))}
    </Root>
  );
};
